import { Component, inject, Inject } from '@angular/core';
import { Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseComponent } from 'src/app/core/components/base/base.component';
import { CriarMovimentacaoCadastralPayload } from 'src/app/core/models/movimentacao-cadastral/CriarMovimentacaoCadastralPayload';
import { CriarMovimentacaoCadastralResponse } from 'src/app/core/models/movimentacao-cadastral/CriarMovimentacaoCadastralResponse';
import { TipoMovimentacao } from 'src/app/core/models/movimentacao-cadastral/TipoMovimentacao';
import { MovimentacaoCadastralService } from 'src/app/core/services/movimentacao-cadastral';

@Component({
  selector: 'app-modal-nova-importacao',
  templateUrl: './modal-nova-importacao.component.html',
  styleUrls: ['./modal-nova-importacao.component.scss'],
})
export class ModalNovaImportacaoComponent extends BaseComponent {
  movimentacaoCadastralService = inject(MovimentacaoCadastralService);
  matDialogRef =
    inject<MatDialogRef<ModalNovaImportacaoComponent>>(MatDialogRef);

  formGroup = this.buildForm();

  submitted = false;

  isLoading = false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
    super();
  }

  get descricaoArquivo(): string {
    const { value } = this.formGroup.controls.documento;

    if (value) {
      return value.name;
    }

    return 'Arquivo de importação';
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.formGroup.invalid) {
      this.notification.info('Preencha os campos corretamente');
      return;
    }

    if (this.data?.mock) {
      this.close();
      return;
    }

    this.criarMovimentacaoCadastral();
  }

  close(): void {
    this.matDialogRef.close({ reload: true });
  }

  private criarMovimentacaoCadastral(): void {
    this.isLoading = true;

    this.movimentacaoCadastralService
      .criarMovimentacaoCadastral(this.getCriarMovimentacaoCadastralPayload())
      .pipe(this.takeUntilDestroyed())
      .subscribe((response) => this.criarMovimentacaoCadastralSuccess(response))
      .add(() => {
        this.isLoading = false;
      });
  }

  private criarMovimentacaoCadastralSuccess(
    response: CriarMovimentacaoCadastralResponse
  ): void {
    this.close();

    if (response.criticas.length) {
      response.criticas.forEach((critica) =>
        this.notification.info(critica.mensagem)
      );
      return;
    }

    this.notification.success(
      'Estamos processando o documento. Acompanhe o processamento da importação'
    );
  }

  private buildForm() {
    return this.fb.group({
      tipoMovimentacao: this.fb.control<TipoMovimentacao | null>(
        null,
        Validators.required
      ),
      documento: this.fb.control<File | null>(null, Validators.required),
    });
  }

  private getCriarMovimentacaoCadastralPayload(): CriarMovimentacaoCadastralPayload {
    const { tipoMovimentacao, documento } = this.formGroup.getRawValue();

    if (tipoMovimentacao == null || !documento) {
      throw new Error('O formulário está inválido');
    }

    return {
      tipoMovimentacao,
      documento,
    };
  }
}
